import styled from "styled-components";

const Background = styled.div`
  background-color: #607d54;
  width: calc(100% - 2rem);
  height: calc(100% - 2rem);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  display: flex;
`;

export default Background;
